import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CommunityDashboard from '@src/features/tenant/community/CommunityDashboard';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CommunityIndex() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout withoutParentPadding>
        <CommonHelmet />
        <CommunityDashboard />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CommunityIndex;
